import { TextTooltip } from '~/@mid_ui/text-tooltip/TextTooltip'

export const investmentTooltips = {
  total: <TextTooltip text="Súčet investovanej čiastky s výnosom" />,
  payoutDate: (
    <TextTooltip text="Dátum, kedy mi bude vyplatená investícia s výnosom" />
  ),
  createdAt: <TextTooltip text="Dátum objednávky investície" />,
  status: <TextTooltip text="Aktuálny stav investície" />,
  investmentExtended: (
    <div className="mt-0">
      <TextTooltip text="Úroky bežia ďalej podľa dohody" />
    </div>
  ),
}
